import styled from "styled-components";

export const ContentPage = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

export const BreadcrumbsContainer = styled.div`
    width: 100%;
    padding: 8px 16px;
`;

export const ConversationPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 24px 32px;
    gap: 24px;
    flex: 1;
    overflow: hidden;
`;

export const ConversationPageHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
`;

export const ConversationPageContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    flex: 1;
    gap: 16px;
    overflow-y: auto;
    overflow-x: hidden;

    /* Estilos para el scrollbar en navegadores basados en WebKit (Chrome, Edge, Safari) */
    &::-webkit-scrollbar {
        width: 8px; /* Ancho del scrollbar */
    }

    &::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.1);
        border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
        background: ${(props) => props.theme.colors.clearGray}; /* Color del scrollbar */
        border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #1f1f1f; /* Color al pasar el mouse */
    }
`;